import React, { Component } from 'react'
import { Input } from 'reactstrap'

class AnswersHtmlEditor extends Component {
  render() {
    const {
      contents,
      handleChange,
      contentType, } = this.props

    return (
      <Input 
        type='textarea'
        name='contents'
        value={contents}
        onChange={(e) => handleChange(e.target.value)}
        rows={contentType === 'answer' ? '3' : '12'}
      />
    )
  }
}

export default AnswersHtmlEditor


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/AnswersHtmlEditor.js